import React, { ReactNode } from "react";
import { Link as ILink, ValidationErrorReason } from "@models/ISchema";
import LinkRouter from "@common/components/link-router";
import i18n from "@config/i18n";
import css from "./linkErrors.module.scss";

export const LINK_HAS_LABEL_ASSIGNED = "LINK_HAS_LABEL_ASSIGNED";
export const LINK_LABEL_ALREADY_IN_USE = "LINK_LABEL_ALREADY_IN_USE";
export const USER_CANNOT_EDIT_LINK = "USER_CANNOT_EDIT_LINK";

interface LinkErrorRecord {
  [reason: string]: (params?: any) => { title: ReactNode; message: ReactNode };
}

export const LINK_ERROR_LABELS: LinkErrorRecord = {
  [LINK_HAS_LABEL_ASSIGNED]: () => ({
    title: i18n.t("link-errors.link-has-label-assigned.title"),
    message: i18n.t("link-errors.link-has-label-assigned.message"),
  }),
  [ValidationErrorReason.LinkCodeAlreadyInUse]: () => ({
    title: i18n.t("link-errors.link-code-already-in-use.title"),
    message: "",
  }),
  [LINK_LABEL_ALREADY_IN_USE]: (params: {
    link: ILink;
    scenario: string;
    workspace: string;
    origin: string;
  }) => ({
    title: i18n.t("link-errors.link-label-already-in-use.title"),
    message: (
      <>
        {i18n.t("link-errors.link-label-already-in-use.message")} [
        <LinkRouter
          className={css.LinkRouter}
          colored
          to={`/scheduler/editor/link/${params?.workspace}/${params?.scenario}/${params?.origin}/${params?.link?.id}`}
        >
          {params?.link?.code}
        </LinkRouter>
        ].
      </>
    ),
  }),
  [USER_CANNOT_EDIT_LINK]: () => ({
    title: i18n.t("link-errors.user-cannot-edit-link.title"),
    message: i18n.t("link-errors.user-cannot-edit-link.message"),
  }),
};
